<script setup lang="ts">
defineProps<{
  text: string | null;
  type: "success" | "error" | "info";
}>();
</script>

<template>
  <div
    v-if="text"
    class="message"
    v-bind:class="`message-${type}`"
  >
    {{ text }}
  </div>
</template>

<style lang="scss" scoped>
.message {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  line-height: 1.5;
  border: 1px solid transparent;

  &-success {
    background-color: var(--colorSuccessBackground);
    color: var(--colorSuccess);
    border-color: var(--colorStatusSuccessStroke1);
  }

  &-error {
    background-color: var(--colorErrorBackground);
    color: var(--colorError);
    border-color: var(--colorStatusDangerStroke1);
  }

  &-info {
    background-color: var(--colorInfoBackground);
    color: var(--colorInfo);
    border-color: var(--colorStatusInfoStroke1);
  }
}
</style>
